import React from "react";
import { withStyles } from "@material-ui/core/styles";
import TrendingEventChart from "../charts/TrendingEventChart";
import * as d3 from "d3";
import moment from "moment";
import { Grid } from "@material-ui/core";

const styles = theme => ({});

function handleEventMarkerSelected(marker) {
  console.log(marker);
}

function getMarkerCategory(marker) {
  //TODO: examine the page data to see the type of change
  return "default";
}

// TODO: TrendingEventChart needs to calculate the width based on container instead of it being hard-coded
class ItemHistory extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      popover: null
    };

    this.handleDotHover = this.handleDotHover.bind(this);
  }

  handleDotHover(data) {
    if (data) {
      this.setState({ popover: data });
    } else {
      this.setState({ popover: null });
    }
  }

  render() {
    const { classes, pageVisitHistory, pageVersionHistory } = this.props;
    const { popover } = this.state;

    console.log({ popover });

    return (
      <div className={classes.root}>
        <Grid container direction="row" spacing={8}>
          <Grid item xs={12} sm={12} md={12} style={{ height: "150px", position: "relative" }}>
              <TrendingEventChart
                id="valuePerVisitTrendEvents"
                height={450}
                width={1200}
                trendData={pageVisitHistory}
                getTrendDate={d =>
                  d3.time
                    .format("%d-%m-%Y")
                    .parse(moment(d.date).format("DD-MM-YYYY"))
                }
                getTrendValue={d => d.value / d.visits}
                getTrendValue2={d => d.visits}
                getEventDate={d =>
                  d3.time.format("%Y%m%dT%H%M%SZ").parse(d.lastUpdated)
                }
                getMarkerCategory={getMarkerCategory}
                getName={this.getName}
                xLabel="Date"
                yLabel="Value Per Visit"
                onDotHover={this.handleDotHover}
                onEventMarkerSelected={this.handleEventMarkerSelected}
              />
          </Grid>
        </Grid>
      </div>
    );
  }
}

export default withStyles(styles)(ItemHistory);



// WEBPACK FOOTER //
// ./src/components/ItemHistory.js